import {
    deleteNumberOfConversations,
    deleteNumberOfItems,
    deleteNumberOfConversationsWhenCountIsNegative,
    deleteNumberOfItemsWhenCountIsNegative,
} from '../../strings.locstring.json';
import { deleteItem } from 'owa-locstrings/lib/strings/deleteitem.locstring.json';
import loc, { format } from 'owa-localize';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

import { ActionSource } from 'owa-mail-store';

import { MAX_LABEL_ITEM_COUNT } from 'owa-mail-store/lib/utils/bulkTriageConstants';
import { trace } from 'owa-trace';

/**
 * Gets the confirm text for delete all dialog.
 * @param actionSource Action that initiated the delete all action
 * @param listViewType The view type of the folder being deleted
 * @param totalCount The total count of items in folder
 * @returns The text shown in delete all confirmation dialog
 */
export default function getDeleteAllConfirmText(
    actionSource: ActionSource,
    listViewType: ReactListViewType,
    totalCount: number
): string {
    const isMessageView = listViewType === ReactListViewType.Message;

    /**
     * Special-case "ContextFolder" because the TotalCount received from the
     * Folder object is always message count.
     */
    const useItemStrings = actionSource === 'ContextFolder' || isMessageView;

    // Do not show the count if it happens to be negavtive
    if (totalCount < 0) {
        trace.warn('totalCount should not be negative.');
        return useItemStrings
            ? loc(deleteNumberOfItemsWhenCountIsNegative)
            : loc(deleteNumberOfConversationsWhenCountIsNegative);
    }

    if (totalCount == 0) {
        trace.warn('getDeleteAllConfirmText should not be called.');
        return '';
    }

    if (totalCount == 1) {
        return loc(deleteItem);
    }

    if (totalCount < MAX_LABEL_ITEM_COUNT) {
        return useItemStrings
            ? format(loc(deleteNumberOfItems), totalCount)
            : format(loc(deleteNumberOfConversations), totalCount);
    }

    return useItemStrings
        ? format(loc(deleteNumberOfItems), '10000+')
        : format(loc(deleteNumberOfConversations), '10000+');
}
